import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { APAdjustmentEditorResultDto } from './ap-adjustment-editor-result-dto';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { VendorLineItemTemplateRawDto } from '../../../../../shared-workflow-module/_models/vendor-lineItem-template-raw-dto';
const ɵ0 = () => APAdjustmentEditorResultDto, ɵ1 = () => VendorLineItemTemplateRawDto, ɵ2 = () => DimensionOptionResultDto;
export class APAdjustmentEditorForApplyPaymentWithAPCMResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", APAdjustmentEditorResultDto)
], APAdjustmentEditorForApplyPaymentWithAPCMResultDto.prototype, "editor", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentEditorForApplyPaymentWithAPCMResultDto.prototype, "vendorLineItemTemplates", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentEditorForApplyPaymentWithAPCMResultDto.prototype, "paymentRequiredDimensions", void 0);
export { ɵ0, ɵ1, ɵ2 };
